<!-- Loading GIF Panel -->
<div #loadingDiv class="loadingDiv" *ngIf="isLoading">
    <img src="/assets/images/Forensic_Notes_Logo.png" class="loadingLogo" tooltip="Loading Forensic Notes" />
    <img src="/assets/images/loading-gif-png-5.gif" class="loadingAppGif" tooltip="Loading Forensic Notes" />
</div>

<!-- Main content - Hide till fully loaded -->
<div class="cm" [ngClass]="{'hidden' : isLoading}">
    <div class="st-head">
        <div class="st-head-copy">
            <div class="st-eyebrow">Organization</div>
            <h1 class="st-h1">Case Management</h1>
            <p class="st-lead">Shape the case and project structure to match how your organization actually works.</p>
        </div>
    </div>

    <!--
    CMS Levels
    0 = not set
    1 = Law Enforcement
    2 = Private Industry
-->
    <section class="st-panel">
        <div class="st-panel-head">
            <mat-icon>account_tree</mat-icon>
            <h2 class="st-h2">CMS structure</h2>
        </div>
        <p class="st-panel-lead">Which model does your organization follow? This decides which options appear below.</p>

        <div class="cm-choices">
            <div class="cm-choice" *ngFor='let curr of cmsTypeOptions'>
                <ejs-radiobutton [label]='curr.text' (click)="clickLevel(curr.value)" [value]="curr.value"
                    name="curr.value" [(ngModel)]="cmsType" color="primary"></ejs-radiobutton>
            </div>
        </div>
    </section>

    <!-- Additional Options -->
    <!-- Show Different Options if CMS == 1 or 2 (Law Enforcement or Private Industry) -->
    <div *ngIf="adminCmsSettingsModel.cmsType != 0">

        <section class="st-panel">
            <div class="st-panel-head">
                <mat-icon>extension</mat-icon>
                <h2 class="st-h2">Modules</h2>
            </div>
            <p class="st-panel-lead">Turn on the case types your team handles. Greyed-out modules are not available
                yet.</p>

            <div class="cm-modules">
                <!-- Digital Forensics -->
                <mat-checkbox class="checkbox" color="primary" (change)="EnableDigitalForensicsCMSClick($event)"
                    [(ngModel)]="adminCmsSettingsModel.digitalForensicsCmsActivated">Enable Digital Forensics CMS
                </mat-checkbox>
                <!-- Video Forensics -->
                <mat-checkbox class="checkbox" color="primary" (change)="EnableVideoForensicsCMSClick($event)"
                    [(ngModel)]="adminCmsSettingsModel.videoForensicsCmsActivated">Enable Video Forensics
                    CMS</mat-checkbox>
                <!-- Private Investigators -->
                <mat-checkbox class="checkbox" color="primary" disabled="true"
                    (change)="EnablePrivateInvestigatorsCMSClick($event)"
                    [(ngModel)]="adminCmsSettingsModel.privateInvesgigatorsCmsActivated">Enable Private Investigators
                    CMS
                    (coming
                    soon)
                </mat-checkbox>
                <!-- Cyber -->
                <mat-checkbox class="checkbox" color="primary" disabled="true" (change)="EnableCyberCMSClick($event)"
                    [(ngModel)]="adminCmsSettingsModel.cyberCmsActivated">Enable Cyber CMS (coming
                    soon)</mat-checkbox>
                <!-- OSINT -->
                <mat-checkbox class="checkbox" color="primary" disabled="true" (change)="EnableOsintCMSClick($event)"
                    [(ngModel)]="adminCmsSettingsModel.osintCmsActivated">Enable OSINT CMS (coming
                    soon)</mat-checkbox>
                <!-- Workplace -->
                <mat-checkbox class="checkbox" color="primary" disabled="true"
                    (change)="EnableWorkplaceCMSClick($event)"
                    [(ngModel)]="adminCmsSettingsModel.workplaceInvestigationsCmsActivated">Enable Workplace CMS (coming
                    soon)
                </mat-checkbox>
            </div>
        </section>

        <section class="st-panel">
            <div class="st-panel-head">
                <mat-icon>tune</mat-icon>
                <h2 class="st-h2">CMS general settings</h2>
            </div>

            <div class="st-row">
                <div class="st-row-copy">
                    <b>Custom structure</b>
                    Customizable Case/Project structure to match how your organization conducts business.
                </div>
                <div class="st-row-action">
                    <button type="button" class="st-btn st-btn--ghost buttonWidth"
                        (click)="EditCmsStructure()">Configure</button>
                </div>
            </div>

            <!-- General Settings (if at least one CMS type selected)-->
            <div *ngIf="true">

                <div class="st-row">
                    <div class="st-row-copy">
                        <b>{{customProjectNaming.level2Name}} format</b>
                        Set the {{customProjectNaming.level2Name}}s format — eg: Auto-Increment, Numeric or Freeform
                        Text.
                    </div>
                    <div class="st-row-action">
                        <button type="button" class="st-btn st-btn--ghost buttonWidth"
                            (click)="componentFileFormatOptions.show()">Configure</button>
                    </div>
                </div>

                <div class="st-row">
                    <div class="st-row-copy">
                        <b>{{customProjectNaming.level2Name}} types</b>
                        eg: Homicide, Theft, Theft of Intellectual Property.
                    </div>
                    <div class="st-row-action">
                        <button type="button" class="st-btn st-btn--ghost buttonWidth"
                            (click)="componentIncidentType.show()">Configure</button>
                    </div>
                </div>

                <div class="st-row">
                    <div class="st-row-copy">
                        <b>{{customProjectNaming.level2Name}} (current list)</b>
                        Add, edit or delete the {{customProjectNaming.level2Name}}s that you investigate.
                    </div>
                    <div class="st-row-action">
                        <button type="button" class="st-btn st-btn--ghost buttonWidth"
                            (click)="componentIncidentNumbers.show()">Manage</button>
                    </div>
                </div>

                <!-- <div class="rowFullWrap">
                    <div class="column50">
                        <button class="SiteColor buttonWidth" (click)="componentReceivedMethod.show()">Exhibit Receiving
                            Methods</button>
                    </div>
                    <div class="column50">
                        eg: by Hand, via Email, via Cloud Storage
                    </div>
                </div>

                <div class="rowFullWrap">
                    <div class="column50">
                        <button class="SiteColor buttonWidth" (click)="componentWorkRequestStatus.show()">Work Request
                            Status</button>
                    </div>
                    <div class="column50">
                        eg:
                    </div>
                </div>

                <div class="rowFullWrap">
                    <div class="column50">
                        <button class="SiteColor buttonWidth" (click)="componentWorkRequestDocumentType.show()">File
                            Upload Document Types</button>
                    </div>
                    <div class="column50">
                        eg: Warrant, Digital Forensics Request Form, etc.
                    </div>
                </div> -->
            </div>
            <!-- (end of) General Settings -->
        </section>

        <!-- PRIVATE INDUSTRY Settings - Show if Level 2 -->
        <!-- <div *ngIf="adminCmsSettingsModel.cmsType == 2">
                    <h3>Private Industry</h3>

                </div> -->

        <!-- LAW ENFORECEMENT Settings - Show if Level 1 -->
        <section class="st-panel" *ngIf="adminCmsSettingsModel.cmsType == 1">
            <div class="st-panel-head">
                <mat-icon>local_police</mat-icon>
                <h2 class="st-h2">Law enforcement</h2>
            </div>

            <div class="st-row">
                <div class="st-row-copy">
                    <b>Org units / teams</b>
                    eg: Homicide, Robbery, Patrol, etc.
                </div>
                <div class="st-row-action">
                    <button type="button" class="st-btn st-btn--ghost buttonWidth"
                        (click)="componentOrgTeam.show()">Manage</button>
                </div>
            </div>
        </section>

        <!-- DIGITAL FORENSICS -->
        <!-- <div *ngIf="adminCmsSettingsModel.digitalForensicsCmsActivated">
                    <h3>Digital Forensics</h3>
                    <div class="rowFullWrap">
                        <div class="column50">
                            button...
                        </div>
                        <div class="column50">
                            eg: ...
                        </div>
                    </div>
                </div> -->

        <!-- VIDEO FORENSICS -->
        <section class="st-panel" *ngIf="adminCmsSettingsModel.videoForensicsCmsActivated">
            <div class="st-panel-head">
                <mat-icon>videocam</mat-icon>
                <h2 class="st-h2">Video forensics</h2>
            </div>

            <div class="st-row">
                <div class="st-row-copy">
                    <b>BIN types</b>
                    Categories used to group video exhibits.
                </div>
                <div class="st-row-action">
                    <button type="button" class="st-btn st-btn--ghost buttonWidth"
                        (click)="componentBINType.show()">Manage</button>
                </div>
            </div>

            <!-- <div class="rowFullWrap">
                        <div class="column50">
                            <button class="SiteColor buttonWidth" (click)="componentWorkRequestExhibitType.show()">Media
                                Types</button>
                        </div>
                        <div class="column50">
                            eg: USB Flash Drive, DVD, etc.
                        </div>
                    </div> -->
        </section>

        <app-case-management-incident-numbers #componentIncidentNumbers></app-case-management-incident-numbers>
        <app-case-management-org-team #componentOrgTeam></app-case-management-org-team>
        <app-case-management-incident-type #componentIncidentType></app-case-management-incident-type>
        <app-case-management-bin-type #componentBINType></app-case-management-bin-type>
        <app-case-management-received-method #componentReceivedMethod></app-case-management-received-method>
        <app-case-management-work-request-document-type #componentWorkRequestDocumentType>
        </app-case-management-work-request-document-type>
        <app-case-management-work-request-status #componentWorkRequestStatus>
        </app-case-management-work-request-status>
        <app-case-management-work-request-exhibit-type #componentWorkRequestExhibitType>
        </app-case-management-work-request-exhibit-type>
        <app-file-format-options #componentFileFormatOptions></app-file-format-options>
        <!-- <app-case-management-structure #componentCaseManagementStructure></app-case-management-structure> -->
        <app-settings-cms-structure #componentCaseManagementStructure></app-settings-cms-structure>

    </div>
</div>
